"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CacheMap = /** @class */ (function () {
    function CacheMap(limit, onDrop) {
        this.limit = limit;
        this.onDrop = onDrop;
        this.seq = 0;
        this.count = 0;
        this.persistCount = 0;
        this.oldestNum = 0;
        this.byKey = new Map();
        this.byNum = new Map();
    }
    CacheMap.prototype.set = function (k, v, persist) {
        if (persist === void 0) { persist = false; }
        var originlPack = this.byKey.get(k);
        if (originlPack) {
            if (this.onDrop && originlPack.v == v) {
                console.info("CacheMap[" + k + "] is assigned twice to same value. This may cause unexpected onDrop callback.");
            }
            this.deleteByPack(originlPack);
        }
        var newPack = { k: k, v: v, num: this.seq++, persist: persist };
        this.byKey.set(k, newPack);
        this.byNum.set(newPack.num, newPack);
        this.count++;
        persist && this.persistCount++;
        this.deleteOldItems();
    };
    CacheMap.prototype.peek = function (k) {
        var p = this.byKey.get(k);
        return p ? p.v : undefined;
    };
    CacheMap.prototype.get = function (k) {
        var pack = this.byKey.get(k);
        if (pack) {
            this.byNum.get(pack.num);
            this.byNum.delete(pack.num);
            this.byNum.set(pack.num = this.seq++, pack);
            return pack.v;
        }
    };
    CacheMap.prototype.keys = function () {
        var keys = [];
        this.byNum.forEach(function (pack) { return keys.push(pack.k); });
        return keys;
    };
    CacheMap.prototype.clear = function () {
        var packs = [];
        this.byNum.forEach(function (pack) { return packs.push(pack); });
        for (var _i = 0, packs_1 = packs; _i < packs_1.length; _i++) {
            var pack = packs_1[_i];
            this.deleteByPack(pack);
        }
    };
    CacheMap.prototype.delete = function (k) {
        var pack = this.byKey.get(k);
        if (pack) {
            this.deleteByPack(pack);
            return true;
        }
        return false;
    };
    CacheMap.prototype.setLimit = function (limit) {
        this.limit = limit;
        this.deleteOldItems();
    };
    CacheMap.prototype.deleteOldItems = function () {
        var totalLimit = this.limit + this.persistCount;
        while (this.count > totalLimit) {
            var pack = this.byNum.get(this.oldestNum++);
            pack && !pack.persist && this.deleteByPack(pack);
        }
    };
    CacheMap.prototype.deleteByPack = function (pack) {
        this.byKey.delete(pack.k);
        this.byNum.delete(pack.num);
        this.onDrop && this.onDrop(pack.v, pack.k);
        this.count--;
        pack.persist && this.persistCount--;
    };
    Object.defineProperty(CacheMap.prototype, "size", {
        get: function () {
            return this.byNum.size;
        },
        enumerable: true,
        configurable: true
    });
    return CacheMap;
}());
exports.CacheMap = CacheMap;
